import React from "react";
import { Card, CardBody, Row, Col } from "reactstrap";

export default function StatCard({ title, value, icon, color = "primary" }) {
  return (
    <Card className="shadow">
      <CardBody>
        <Row>
          <Col>
            <h5 className="card-title text-uppercase text-muted mb-0">{title}</h5>
            <span className="h2 font-weight-bold mb-0">{value ?? "—"}</span>
          </Col>
          <Col className="col-auto">
            <div className={`icon icon-shape bg-${color} text-white rounded-circle shadow`}>
              <i className={icon} />
            </div>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
}
